import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import { useAtom } from "jotai";
import { appearanceAtom } from "@/stores/appearance-atom";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: Readonly<ToasterProps>) => {
  const { theme = "system" } = useTheme();
  const [appearance] = useAtom(appearanceAtom);

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className={`toaster group font-${appearance.font}`}
      // toastOptions={{
      //   classNames: {
      //     toast:
      //       "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
      //     description: "group-[.toast]:text-muted-foreground",
      //     actionButton:
      //       "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
      //     cancelButton:
      //       "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
      //   },
      // }}
      {...props}
    />
  );
};

export { Toaster };
